<template>
  <div class="referral">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div />
        <qrcodeVue
          :value="this.link"
          :size="200"
          class="qrcode"
          :style="[
            this.getlink ? { visibility: 'visible' } : { visibility: 'hidden' },
          ]"
        />
        <div class="linkBox">
          <input id="referralLink" v-model="this.link">
        </div>
        <div class="btnItem">
          <p class="sucMessage">{{ this.sucMessage }}</p>
          <span
            ref="copy"
            class="submit"
            :class="{ addSuc: this.getlink }"
            data-clipboard-target="#referralLink"
            @click="copyLink"
          >
            复制链接</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/referral.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import Clipboard from 'clipboard'
export default {
  name: 'Referral',
  components: { Header, QrcodeVue },
  computed: {
    ...mapState(['user']),
    referParam: {
      get() {
        return {
          customerNumber: this.user.loginname
        }
      }
    }
  },
  data() {
    return {
      title: '邀请好友',
      link: '',
      getlink: false,
      sucMessage: '',
      rightContent: 'isNo',
      copyBtn: null
    }
  },
  mounted() {
    this.$bus.$emit('loading', true)
    this.getReferralLink()
    // enable copy function
    this.copyBtn = new Clipboard(this.$refs.copy)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  activated() {
    this.$bus.$emit('loading', true)
  },
  methods: {
    getReferralLink() {
      const data = { phone: this.user.loginname }
      const readyData = this.$qs.stringify(data)
      api.getReferralLink(readyData).then((res) => {
        if (res.data.code === 1) {
          this.link = res.data.msg
          this.getlink = true
        }
      })
    },
    copyLink() {
      const _this = this
      const clipboard = this.copyBtn
      clipboard.on('success', function() {
        _this.sucMessage = '复制成功！'
      })
      clipboard.on('error', function() {
        _this.sucMessage = '复制失败，请手动选择复制！'
      })
    }
  }
}
</script>
